module.exports = __webpack_public_path__ + "static/media/holiday_work_request.55686b25.svg";